<ng-container *transloco="let t">
  @if (race) {
    <div class="live-race-list-item flex-column flex-xxl-row d-flex align-items-start p-3 mb-4 mb-xxl-0">
      <div class="badge-holder mb-3 mb-xxlo-0">
        <div class="badge-holder__badge" [ngClass]="
          {'finished': status === LiveItemStatus.FINISHED,
          'in-progress': status === LiveItemStatus.IN_PROGRESS,
          'to-be-started': status === LiveItemStatus.TO_BE_STARTED,}">
        <span class="text-uppercase">
          {{ t("live.results.status." + status) }}
        </span>
        </div>
      </div>
      <div class="flex-grow-1 ps-0 ps-xxl-3">
        <p class="text-uppercase large">
          <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                               [siLabel]="race?.nameSlo" [srLabel]="race?.nameSr" [bsLabel]="race?.nameBs"
                               [defaultLanguage]="event?.defaultLanguage"
                               [languages]="languages"/>
          + {{ race?.length ? (race?.length | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
        </p>
        <div class="info-details d-flex mb-4 mb-xxl-0">
          <div class="pe-1 d-inline-flex align-items-center d-xxl-none">
            <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time" width="24" height="24"/>
          </div>
          <div class="d-flex">
            <p class="medium">
              {{ t("event.item.start") + ": " }}
            </p>
            <p class="regular">
              {{
                race.raceStart | localizedDate:"HH:mm"
              }}
            </p>
          </div>
          <div class="d-flex">
            <p class="medium">
              {{ t("event.item.date") + ": " }}
            </p>
            <p class="regular">
              {{
                race.raceStart | localizedDate:"shortDate"
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column flex-md-row align-items-end btn-holder">
        <div>
          <app-button-alt [text]="t('live.results.see.big.screen')" [borderColor]="'var(--teal-500)'"
                          [textColor]="'var(--grey-neutral-800)'"
                          (onClickCallback)="goToRaceLiveResultsPage(true)" [buttonColor]="'transparent'"
                          [buttonHeight]="'36px'" [isFullWidth]="true"/>
        </div>
        <div class="ps-0 ps-md-2 pt-3 pt-md-0">
          <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                          [text]="t('live.results.see.all')" [borderColor]="'var(--teal-500)'"
                          (onClickCallback)="goToRaceLiveResultsPage()" [isFullWidth]="true"
                          [buttonHeight]="'36px'"></app-button-alt>
        </div>
      </div>
    </div>
  }
</ng-container>
